export class SimpleHttpError<TData = unknown> extends Error {
  readonly name = "SimpleHttpError"
  type = "SimpleHttpError" as const
  response?: SimpleHttpResponse<TData> | undefined
  requestPath?: string | undefined
  isCancelled?: boolean | undefined
  requestMethod?: string | undefined

  constructor(
    message: string,
    {
      response,
      requestPath,
      requestMethod,
      isCancelled,
    }: {
      response?: SimpleHttpResponse<TData>
      requestPath?: string
      requestMethod?: string
      isCancelled?: boolean
    }
  ) {
    super(message)
    this.response = response
    this.requestPath = requestPath
    this.isCancelled = isCancelled
    this.requestMethod = requestMethod
  }
}

export interface SimpleHttpResponse<TData = unknown> {
  type: "SimpleHttpResponse"
  status?: number
  statusText?: string
  data?: TData
}
